import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import OfficeId              from "../../../domain/office/OfficeId";
import OfficeRepository      from "../../../domain/office/OfficeRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import OfficeDataSource      from "../../../infrastructure/datasource/office/OfficeDataSource";

class SelectOffice {
  private readonly repository: OfficeRepository = new OfficeDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(officeId: OfficeId) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.select(officeId);
      window.location.reload();
    } catch (e) {
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default SelectOffice;